import { defineStore } from 'pinia'
import { authService } from '@/services/auth-service.js'

export const useAuthStore = defineStore('auth', {
    state: () => ({
        user: null,
        isLoading: true,
    }),
    actions: {
        async init() {
            this.isLoading = true
            try {
                const response = await authService.get_session()

                this.user = response?.user || null
            } catch (err) {
                this.user = null
            } finally {
                this.isLoading = false
            }
        },

        clear() {
            this.user = null
            this.isLoading = false
        }
    }
})
